export default __webpack_public_path__ + "2e4d7a30e84afb82adbc9b100a11b48b.mp3";